export default __webpack_public_path__ + "static/media/vivenda-camarao.c63970b2.jpg";